import * as React from "react"
import type { SVGProps } from "react"
const SvgCheckCircleFilledMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M7.04 8.87 5.85 7.68a.8.8 0 0 0-.6-.24.8.8 0 0 0-.83.84q0 .36.24.6l1.75 1.75a.87.87 0 0 0 1.26 0L11.29 7a.8.8 0 0 0 .24-.6.8.8 0 0 0-.24-.58.8.8 0 0 0-.6-.24.8.8 0 0 0-.6.24zM8 14.99a6.8 6.8 0 0 1-4.95-2.04 7 7 0 0 1-1.49-7.68 7 7 0 0 1 3.7-3.7A7 7 0 0 1 8 1a6.8 6.8 0 0 1 4.95 2.04 7 7 0 0 1 1.49 7.68 7 7 0 0 1-3.7 3.7Q9.44 15 8 15" />
  </svg>
)
export default SvgCheckCircleFilledMini
